import React from "react";
import { Location } from "../../types";

const LocationContext = React.createContext<{
  locations: Location[];
  setLocations: any;
}>({ locations: [], setLocations: () => {} });

export default LocationContext;
